import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import ScanSortType from './ScanSortType';
import { setPageToRender, setSelectedSortType, SortContainerPages } from 'src/store/common-slices/sortContainerSlice';
import { resetChildAndDestinationContainers } from 'src/store/common-slices/batchMoveContainersSlice';

const mapStateToProps = (state: RootState) => ({
    getSortTypesOutput: state.SortContainer.getSortTypesOutput,
    selectedSortType: state.SortContainer.selectedSortType
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    setPageToRender: (pageToRender: SortContainerPages) => dispatch(setPageToRender(pageToRender)),
    resetChildAndDestinationContainers: () => dispatch(resetChildAndDestinationContainers()),
    setSelectedSortType: (selectedSortType: string) => dispatch(setSelectedSortType(selectedSortType))
});

export default connect(mapStateToProps, mapDispatchToProps)(ScanSortType);
